module.exports = {
  WarehouseNo: 'Номер поступления на склад',
  Warehouse: 'Наименование склада',
  WarehouseInDate: 'Фактическое время поступления на склад',
  State: 'Статус поступления на склад',
  PackageWarehouseInDate: 'Упаковка - фактическое время поступления',
  PackageWarehouseOutDate: 'Упаковка - фактическое время отгрузки',
  ReceiptNumber: 'Номер квитанции',
  ReceiptNo: 'Номер расписки',
  PortOfDestination: 'Порт назначения',
  StorageDate: 'Время оприходования',
  DeliveryDate: 'Время отгрузки',
  StorageDay: 'Дата оприходования',
  ActStorageDay: 'Фактическая дата оприходования',
  DeliveryDay: 'Дата отгрузки',
  ActDeliveryDay: 'Фактическая дата отгрузки',
  InputTime: 'Время внесения данных',
  DataEntryClerk: 'Ответственный за внесение данных',
  NumberOfCases: 'Количество мест',
  Weight: 'Вес',
  Volume: 'Объем',
  ComputationIsAffectedByDampness: 'Повреждение/увлажнение',
  IsNotComputationIsAffectedByDampness: 'Наличие повреждений/увлажнения',
  ComputationIsAffectedByDampnessNum: 'Количество поврежденных/увлажненных мест',
  IntoTheWarehousePhotos: 'Фото поступления на склад',
  WarehouseName: 'Наименование склада',
  DeliveryMode: 'Способ отгрузки',
  Warehouseman: 'Кладовщик',
  WarehouseLocation: 'Место хранения',
  StorageLocation: 'Место хранения',
  TemperatureRequirement: 'Требование к температуре',
  DeliveryCmp: 'Компания-поставщик',
  IssueOrNot: 'Отгружено ли',
  PalletSum: 'Количество паллет',
  ReceiveDc: 'Получены ли документы',
  LicensePlate: 'Номер автомобиля',
  DescriptionOfGoods: 'Описание груза',
  HandlingOpinions: 'Рекомендации по обработке',
  Remark: 'Примечание',
  SealingWeight: 'Вес таможенного пломбирования',
  Driver: 'Водитель',
  DriverPhone: 'Телефон водителя',
  IsTheGoodsClosed: 'Таможенное пломбирование',
  WarehouseInformation: 'Информация о складе',
  CargoDetails: 'Детализация груза',
  CargoPhotos: 'Фото груза',
  OperationRequirements: 'Требования к операциям',
  SelectFile: 'Выбрать файл',
  DeleteFile: 'Удалить файл',
  AddCargo: 'Добавить груз',
  Detail: 'Детализация',
  Summary: 'Сводка',
  FillData: 'Заполнение',
  maintenanceAllType: 'Номер контейнера и информация о товаре',
  maintenanceContainerNoType: 'Только номер контейнера',
  maintenanceWeightAndSizeType: 'Только информация о товаре',
  DeleteCargo: 'Удаление груза',
  JobNumberInformation: 'Информация о рабочем номере',
  Statistics: 'Статистика',
  Number: 'Количество билетов',
  QuantityActual: 'Фактическое количество мест',
  WeightActual: 'Фактический вес',
  CubageActual: 'Фактический объем',
  WarehouseOutState: 'Статус отгрузки',
  WarehouseInState: 'Статус приемки',
  WarehouseIn: 'Приемка',
  WarehouseOut: 'Отгрузка',
  NewWarehouseFee: 'Добавить складской сбор',
  WarehousePhotos: 'Фотографии склада',
  StorageDayCanNotBeNull: 'Дата приемки не может быть пустой.',
  DeliveryDayCanNotBeNull: 'Дата отгрузки не может быть пустой.',
  WarehouseInSuccess: 'Успешно принято на склад.',
  WarehouseOutSuccess: 'Успешно отгружено',
  NoChoiceWarehouseToBePrinted: 'Не выбрана информация о складе для печати!',
  PleaseSelectTheWarehousingNoticeToBeDeleted: 'Выберите уведомление о приемке для удаления',
  WarehousingNotice: 'Уведомление о приемке',
  AreYouSureToDeleteThisWarehousingNotice: 'Вы уверены, что хотите удалить это уведомление о приемке?',
  DeleteWarehousingNotice: 'Удалить уведомление о приемке',
  ImportingData: 'Идет импорт данных',
  ThisOperationIsAnAsynchronousImport: 'Это асинхронный импорт, результаты можно посмотреть в "Хранилище файлов -> Журнал загрузок"',
  ViewResults: 'Просмотреть результаты',
  BatchImportWarehousing: 'Массовый импорт приемки',
  BatchImportWarehousingData: 'Массовый импорт данных приемки',
  NoWarehouseReceiptSelected: 'Не выбрана накладная приемки',
  Checklist: 'Проверка накладной',
  ReturnGoods: 'Возврат',
  OnlySave: 'Только сохранение',
  Save: 'Сохранить',
  SaveAndWeigh: 'Сохранить и взвесить',
  SaveAndChecklist: 'Сохранить и проверить накладную',
  WeighAndChecklist: 'Взвесить и проверить накладную',
  PoOriginalOrderNo: 'PO (оригинальный номер)',
  ServiceChannel: 'Сервисный канал',
  DestinationDeliveryMethod: 'Способ доставки в пункт назначения',
  OverseasWarehouse: 'Зарубежный склад',
  DestinationCountry: 'Страна назначения',
  Weigh: 'Взвешивание',
  ReceivingWarehouse: 'Склад получателя',
  CommissionNo: 'Номер поручения',
  OverseasWarehouseCode: 'Код зарубежного склада',
  RemoteWarehouse: 'Удаленный склад',
  boxLengthPlaceholder: 'Длина',
  boxWidthPlaceholder: 'Ширина',
  BoxHeightPlaceholder: 'Высота',
  SizeNotZero: 'Длина, ширина, высота и количество мест не могут быть меньше или равны 0',
  EstEnteringAmazonWarehouse: 'Ожидаемое время поступления на склад Amazon',
  ChargingMethod: 'Способ тарификации',
  Total: 'Итого',
  WeighTime: 'Время взвешивания',
  weighCheckMsg: 'Данная информация о поступлении уже {0}, взвешивание невозможно',
  ChecklistTime: 'Время проверки заказа',
  ReturnGoodsTime: 'Время возврата',
  CourierServicesCompany: 'Курьерская служба',
  Electric: 'Содержит ли батареи',
  Magnetic: 'Содержит ли магниты',
  Powdery: 'Является ли порошком',
  Liquid: 'Является ли Жидк.ю',
  BatchMaintenance: 'Массовое обслуживание',
  PickingGoods: 'Комплектация по данным клиента',
  AdjustChargeWeight: 'Корректировка тарифного веса',
  ContainerNo: 'Номер коробки',
  BoxesNumber: 'Количество коробок',
  SingleBoxWeight: 'Вес одной коробки (кг)',
  DialogSingleBoxWeight: 'Вес одной коробки (кг)',
  BoxLength: 'Длина коробки (см)',
  BoxWidth: 'Ширина коробки (см)',
  BoxHeight: 'Высота коробки (см)',
  UnitRate: 'Заявленная цена за единицу (одного товара)',
  Quantity: 'Заявленное количество (одной коробки)',
  BoxSize: 'Размеры одной коробки',
  HsCode: 'Таможенный код',
  Brand: 'Бренд',
  BrandType: 'Тип бренда',
  ModelNo: 'Модель',
  MaterialQuality: 'Материал',
  Purpose: 'Назначение',
  SalesLink: 'Ссылка на продажу',
  SalesPrice: 'Цена продажи',
  PictureUrl: 'Изображение',
  WeightKg: 'Вес (кг)',
  CargoType: 'Тип груза',
  ProductDescription: 'Описание товара',
  CheckWeighTime: 'Данная информация о поступлении уже взвешена, обновить данные взвешивания?',
  ChecklistTimeTip: 'Время проверки заказа [{0}] не может быть меньше времени взвешивания [{1}], проверьте.',
  ReturnReason: 'Причина возврата',
  ReturnGoodsTips: 'Содержит данные {0}, подтвердите возврат?',
  ChecklistResult: 'Результат проверки заказа',
  ModifiedReason: 'Причина изменения заказа',
  WsTjRemark: 'Пояснение к изменению заказа',
  WsTjReason: 'Причина удаления заказа',
  WsTjDelRemark: 'Пояснение к удалению заказа',
  ModifiedWsTjTips: 'Дополнительное пояснение при других причинах',
  FaceOrderPrintTime: 'Время печати курьерской накладной',
  CourierNumber: 'Трек-номер',
  RefContainerNo: 'Эталонный номер коробки',
  isWeigh: 'Взвешено ли',
  isChecklist: 'Проверен ли заказ',
  isReturn: 'Возврат ли',
  ChecklistTip: 'В выбранных данных есть невзвешенные данные, пожалуйста, проверьте.',
  cannotEditOutData: 'Данные, уже отправленные со склада, нельзя редактировать',
  alreadyChecklist: 'Этот заказ уже проверен, пожалуйста, проверьте.',
  delChecklistData: 'Содержит проверенные данные, удаление невозможно.',
  repeatPackingData: 'Содержит уже упакованные данные, повторная упаковка невозможна, пожалуйста, проверьте.',
  ChecklistTipOne: 'В выбранных данных есть невзвешенные данные, проверить заказ?',
  RegistrationSlip: 'Регистрация накладной',
  ContainerNoEditor: 'Редактировать номер грузового ящика',
  PerContainerNo: 'Префикс номера коробки (FBA номер):',
  boxNum: 'Количество коробок:',
  boxSeq: 'Порядковый номер коробки:',
  boxSeqType3: '3-значная длина',
  boxSeqType6: '6-значная длина',
  boxSeqTooLong: 'Порядковый номер коробки превышает максимальное значение [{0}], пожалуйста, проверьте',
  duplicateContainerNo: 'Номер грузового ящика [{0}] уже существует, пожалуйста, заполните заново',
  shipmentIdNotNull: 'Пожалуйста, сначала укажите shipment Id!',
  boxesNumberNotNull: 'Пожалуйста, сначала укажите количество коробок!',
  cargoChineseNameNotNull: 'Пожалуйста, сначала укажите наименование товара на китайском!',
  cargoEnglishNameNotNull: 'Пожалуйста, сначала укажите наименование товара на английском!',
  singleBoxWeightNotNull: 'Пожалуйста, сначала укажите вес одного грузового ящика!',
  boxesSizeNotNull: 'Пожалуйста, сначала укажите размеры одной коробки!',
  boxSeqNotNull: 'Пожалуйста, сначала укажите порядковый номер коробки',
  deleteTheDetailRecord: 'Все данные в текущем списке будут очищены, продолжить?',
  overwriteTheDetailRecord: 'Все данные в текущем списке будут перезаписаны данными клиента, продолжить?',
  overwriteTheDetailRecordByJobRelated: 'Все данные в текущем списке будут перезаписаны данными клиента, продолжить?',
  continuePicking: 'Заказ еще не проверен, продолжить упаковку?',
  continueReturnGoods: 'После возврата операции, такие как консолидация, не будут выполняться, продолжить?',
  editShipmentId: 'Номер грузового ящика не соответствует ShipmentId, обновить номер грузового ящика?',
  editActJmt: 'В данных грузового ящика уже есть значения, изменение сводной информации о весе запрещено!',
  storageAgeEdit: 'Корректировка возраста запасов',
  storageAgeEditDay: 'Дни (автоматический расчет/фактический)',
  storageAgeEditWeek: 'Недели (автоматический расчет/фактический)',
  Packing: 'Упаковка',
  ExWarehouse: 'Отгрузка',
  weightOpCannotChecklist: 'Сохранение запрещено, для проверки заказа нажмите кнопку [Взвесить и проверить заказ].',
  saveCheckContainerNoFail: 'В данных есть записи без указания номера грузового ящика, пожалуйста, проверьте!',
  saveCheckShipmentIdFail: 'В данных есть записи без указания Shipment Id, пожалуйста, проверьте!',
  saveCheckQuantityFail: 'В данных есть записи без указания веса одного грузового ящика, пожалуйста, проверьте!',
  saveCheckBoxLengthFail: 'В данных есть записи без указания длины грузового ящика, пожалуйста, проверьте!',
  saveCheckBoxWidthFail: 'В данных есть записи без указания ширины грузового ящика, пожалуйста, проверьте!',
  saveCheckBoxHeightFail: 'В данных есть записи без указания высоты грузового ящика, пожалуйста, проверьте!',
  saveCheckChineseCargoNameFail: 'В данных есть записи без указания наименования товара на китайском, пожалуйста, проверьте!',
  saveCheckEnglishCargoNameFail: 'В данных есть записи без указания наименования товара на английском, пожалуйста, проверьте!',
  saveCheckBrandFail: 'В данных есть записи без указания бренда, пожалуйста, проверьте!',
  saveCheckBrandTypeFail: 'В данных есть записи без указания типа бренда, пожалуйста, проверьте!',
  FaceListCheckExpressDelivery: 'Способ доставки в пункте назначения не курьерский, регистрация транспортной накладной не требуется',
  FaceListCheckTip: 'Отсутствует информация о взвешивании, продолжить регистрацию данных курьерской накладной?',
  PackingTipOne: 'Содержатся данные о возвращенных отправлениях, упаковка невозможна, проверьте.',
  PackingTipTwo: 'В выбранных данных есть неподтвержденные накладные, продолжить упаковку?',
  ExWarehouseTip: 'В выбранных данных есть уже отгруженные, проверьте',
  LabelingTime: 'Время маркировки',
  Labeling: 'Маркировка',
  Pallet: 'Паллетировать?',
  PalletNo: 'Номер паллеты',
  DaycareInformation: 'Информация о паллетировании',
  PreDeliveryTime: 'Планируемая дата доставки',
  ActDeliveryTime: 'Фактическая дата доставки',
  LogisticsNo: 'Трек-номер логистики',
  OperationStatus: 'Статус обработки на зарубежном складе',
  LogisticsNoEnd: 'Трек-номер логистики (финальный этап)',
  palletContainerNum: 'Количество паллетированных коробок',
  otherContainerNum: 'Количество неупакованных коробок',
  updateIssueRemarks: 'Примечание к отгрузке',
  DateOfService: 'Дата доставки',
  onWarehouseInCheck: 'В выбранных данных есть записи не в статусе "ожидает поступления", проверьте',
  PleaseChooseADataEntry: 'Выберите одну запись!',
  ExternallyImportedDataCannotEdit: 'Данные импортированы извне, редактирование невозможно.',
  CannotEditExternalData: 'Данные импортированы извне, редактирование невозможно.',
  PleaseChooseDesignatedData: 'Выберите указанные данные',
  CargoWareDoorstepVehicleDrivingButton: 'CargoWare - Бизнес-функции - Клиентские точки - Трек транспорта (нажмите кнопку)',
  PlateOrderNumberCannotEmpty: 'Номер машины и номер коносамента обязательны для заполнения',
  NoAvailableAtThisTime: 'Соответствующая информация отсутствует'
}
